import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import { timelineOppositeContentClasses } from '@mui/lab/TimelineOppositeContent';
import { Typography } from '@mui/material';

export default function CusTimeline({ items = [] }) {
  return (
    <>
      <Timeline
        sx={{
          '.MuiTimelineItem-root': {
            ':before': {
              content: 'unset'
            }
          }
        }}
      >
        {items.map(({ id, content, color }) => (
          <TimelineItem key={id}>
            <TimelineSeparator>
              <TimelineDot color={color} />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>{content}</TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </>
  );
}
